import { Component, effect } from '@angular/core';
import { linkedQueryParam } from 'ngxtension/linked-query-param';

/*
 * This component is used to set the gclid cookie based on the navigation.
 * It is used to set the gclid cookie based on the navigation.
 *
 * Prepare new Notion columns GCLID and Consent
 * Save URL query parameter GCLID and save it to cookies. When the form is sent later (in one session or after another direct session) the GCLID is sent to Notion with other data.
 * GCLID is updated when users click on another ad and gets new GCLID.
 * More on GCLID: https://support.google.com/google-ads/answer/7012522?hl=en
 * Consent from Cookieyes cookie(s) also sent with form data to Notion.
 *
 * More on GCLID: https://support.google.com/google-ads/answer/7012522?hl=en
 *
 * Consent from Cookieyes cookie(s) also sent with form data to Notion.
 */

@Component({
    selector: 'gsap-gclid',
    template: ``,
})
export class GclidComponent {
    readonly currentPage = linkedQueryParam('gclid', {
        parse: (value) => value,
    });

    setGclid = effect(() => {
        const param = this.currentPage();
        if (param) {
            // set for 90 days
            const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000);
            document.cookie = `gclid=${param}; path=/; expires=${expires.toUTCString()}`;
        }
    });
}
